import * as mock from "../mocks/reportBuilder.mock.js";

export function listReportDatasets() {
  return mock.listReportDatasets();
}

export function getReportDataset(datasetId) {
  return mock.getReportDataset(datasetId);
}

export function estimateReport(config) {
  return mock.estimateReport(config);
}

export function saveReport(payload) {
  return mock.saveReport(payload);
}

export function listSavedReports() {
  return mock.listSavedReports();
}
